import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";

import { CatalogService } from "../../services/catalog.service";

import { Product } from "../../interface/product";

import { CookieService } from "ngx-cookie";

import "rxjs/add/operator/mergeMap";
import { Storage } from "../../storage/storage";

import { ConfirmComponent } from "../detail-pdt/detail-pdt.component";

import { DialogService } from "ng2-bootstrap-modal";
import { FilterProductsPipe } from "../../pipes/filter-products.pipe";

@Component({
  selector: "app-catalog",
  templateUrl: "./catalog.component.html",
  styleUrls: ["./catalog.component.css"],
  providers: [CatalogService, FilterProductsPipe],
})
export class CatalogComponent implements OnInit {
  catalogId: any;
  products: Array<Product>;
  categories: any;
  productsTemp;
  catalogName: string;
  token: any;
  itemsPerPageValue: Number;
  items: Array<any> = ["10", "20", "50", "100"];
  private value: any = {};
  productsLength: Number;
  categorySelected: string;
  showLoader: Boolean;
  cartPrice: number;
  cartItem: any;
  selectedProduct: Product;
  p: any;
  mymodel: any;
  message: string;
  test: any;
  selectedItem: any;

  @Output()
  openModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private route: ActivatedRoute,
    private catalogSrv: CatalogService,
    private location: Location,
    private _cookieService: CookieService,
    private storage: Storage,
    private dialogService: DialogService,
    private filterProductsPipe: FilterProductsPipe,
    private router: Router
  ) {
    this.itemsPerPageValue = 10;
    this.selectedItem = 10;
    this.categorySelected = "All Products";
    this.products = [];
    this.showLoader = true;
    this.cartItem = 0;
    this.cartPrice = 0;
  }

  itemPerPageChange(itemPerPages: number) {
    this.itemsPerPageValue = itemPerPages;
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }
  search() {
    this.products = this.productsTemp;
    this.categorySelected = "All Products";
  }
  goToCart() {
    this.router.navigate(["cart/", this.catalogId]);
  }
  selectCat(category) {
    this.categorySelected = category.categorie_name;
    this.mymodel = "";
    if (category.categorie_name === "All Products") {
      this.products = this.productsTemp;
    } else {
      this.products = this.productsTemp.filter(
        (pdt) => pdt["unspsc"] === category.categorie_code
      );
    }
  }
  increment(pdt) {
    let index = this.products.indexOf(pdt);
    this.products[index]["quantity"] = this.products[index]["quantity"] + 1;
  }
  decrement(pdt) {
    let index = this.products.indexOf(pdt);
    if (this.products[index]["quantity"] > 1) {
      this.products[index]["quantity"] = this.products[index]["quantity"] - 1;
    }
  }
  addtocart(pdt) {
    let indexInCart = this.storage.cart.findIndex(
      (item) => item.sup_part_num === pdt.sup_part_num
    );
    let indexInProducts = this.products.findIndex(
      (item) => item.sup_part_num === pdt.sup_part_num
    );
    if (indexInCart === -1) {
      this.storage.cart.push({
        short_description: pdt.short_description,
        sup_part_num: pdt.sup_part_num,
        sup_part_aux_num: pdt.sup_part_id,
        quantity: pdt.quantity,
        price: pdt.price.eur,
        url_photo: pdt.url_photo,
        mfr_number: pdt.mfr_number,
        mfr_name: pdt.mfr_name,
        language: pdt.language,
        id: pdt._id,
        currency: pdt.currency,
        uom: pdt.uom,
        unspsc: pdt.unspsc,
      });
    } else {
      this.storage.cart[indexInCart].quantity =
        this.storage.cart[indexInCart].quantity + pdt.quantity;
    }
    this.products[indexInProducts].quantity = 1;
    this.refreshCart();
  }

  refreshCart() {
    this.cartItem = this.storage.cart.reduce((prev, item1) => {
      return prev + item1.quantity;
    }, 0);
    this.cartPrice = this.storage.cart.reduce((prev, item1) => {
      return prev + item1.price * item1.quantity;
    }, 0);
  }
  openModalDetailPdt(pdt) {
    this.openModal.emit(true);
    this.selectedProduct = pdt;
    let disposable = this.dialogService
      .addDialog(ConfirmComponent, {
        short_description: this.selectedProduct.short_description,
        long_description: this.selectedProduct.long_description,
        unspsc: this.selectedProduct.unspsc,
        quantity: this.selectedProduct.quantity,
        sup_part_num: this.selectedProduct.sup_part_num,
        price: this.selectedProduct.price.eur,
        url_photo: this.selectedProduct.url_photo,
        mfr_number: this.selectedProduct.mfr_number,
        currency: this.selectedProduct.currency,
        uom: this.selectedProduct.uom,
      })
      .subscribe((isConfirmed) => {
        this.refreshCart();
      });
  }

  ngOnInit() {
    this.refreshCart();
    if (this.storage.hook_url === undefined) {
      this.router.navigate(["welcome/1"]);
    } else {
      this.route.params
        .map((params) => params["catalogId"])
        .mergeMap((catalogId) => {
          this.catalogId = catalogId;
          this.token = this._cookieService.get("NendiToken");
          return this.catalogSrv.getCatalog(this.catalogId, this.token);
        })
        .subscribe(
          (data) => {
            console.log(data.catalogue.products);
            data.catalogue.products.map((pdt) => {
              pdt.quantity = 1;
            });
            this.productsTemp = data.catalogue.products;
            this.products = data.catalogue.products;
            this.categories = data.catalogue.categories;
            this.catalogName = data.catalogue.name;
            this.productsLength = data.catalogue.products.length;
            this.showLoader = false;
            this.location.replaceState("oracle/catalog/" + this.catalogId);
          },
          (err) => {
            console.error("Catalog load error", err);
            this.showLoader = false;
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalog/catalog.component.ts